export type { WebgeePageProps } from './WebgeePage/WebgeePage';
export { default as WebgeePage } from './WebgeePage/WebgeePage';